import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Teams } from "appwrite";
import client from "../appwrite";
import {
  Box,
  Typography,
  CircularProgress,
  Alert,
  Button,
} from "@mui/material";

const teams = new Teams(client);

export default function ConfirmMembership() {
  const [searchParams] = useSearchParams();

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const teamId = searchParams.get("teamId");
  const membershipId = searchParams.get("membershipId");
  const userId = searchParams.get("userId");
  const secret = searchParams.get("secret");

  const confirm = async () => {
    setLoading(true);
    try {
      await teams.updateMembershipStatus(teamId, membershipId, userId, secret);
      setMessage("Team membership confirmed! 🎉");
    } catch (err) {
      console.error("Confirmation error:", err);
      setError(err.message || "Could not confirm membership.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (teamId && membershipId && userId && secret) {
      confirm();
    } else {
      setError("Missing confirmation parameters.");
      setLoading(false);
    }
  }, [teamId, membershipId, userId, secret]);

  return (
    <Box
      sx={{
        maxWidth: 500,
        mx: "auto",
        mt: 8,
        p: 4,
        borderRadius: 2,
        boxShadow: 4,
        textAlign: "center",
      }}
    >
      <Typography variant="h5">Confirming Membership</Typography>

      {loading && <CircularProgress sx={{ mt: 2 }} />}
      {message && (
        <Alert severity="success" sx={{ mt: 2 }}>
          {message}
        </Alert>
      )}
      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}

      {error && !loading && (
        <Button onClick={confirm} sx={{ mt: 2 }} variant="contained">
          Retry
        </Button>
      )}
    </Box>
  );
}
